import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function removeSpecialChars(key: string) {
  return key?.trim().toLowerCase()?.replace(/[^a-z0-9 _-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
}

export function toBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
      } else {
        reject(new Error("File could not be converted to base64 string"));
      }
    };
    reader.onerror = (error) => reject(error);
  });
}

export const renderTableText = (value: string, className?: string) => value ? <span className={cn(className)}>{value}</span> : <span>NA</span>

export const handleTableSortingData = (sorter: any, setSort: any, curr_sort: any, refetch: any, qData: any) => {
  const updateSortAndRefetch = (newSort: any) => {
      setSort(newSort);
      if (typeof refetch === 'function') {
          refetch({ ...qData, sort: JSON.stringify(newSort) });
      }
  };
  // Multi-sort mode (array)
  if (Array.isArray(sorter) && sorter.length > 0) {
      const sortKeys = sorter
          .filter((item: any) => item.order)
          .map((item: any) => ({
              column: item.field,
              desc: item.order === 'ascend' ? 0 : 1,
          }));
      return updateSortAndRefetch(sortKeys);
  }
  // Single-sort mode (object)
  const { order, field } = sorter || {};
  if (!field) return;

  const newSortItem = {
      column: field,
      desc: order === 'ascend' ? 0 : 1,
  };

  if (order) {
      updateSortAndRefetch([newSortItem]);
  } else {
      // Sort removed for this column
      const filtered = curr_sort.filter((x: any) => x.column !== field);
      return updateSortAndRefetch(filtered);
  }
};

export const renderWithoutUnderscore = (val: string) =>{
  return val.split('_').join(' ')
}

export function isValidLink(text: string): boolean {
  try {
    new URL(text);
    return true; // valid
  } catch {
    return false; // invalid
  }
}

export const getCroppedImg = (
  file: File,
  croppedAreaPixels: {
    width: number;
    height: number;
    x: number;
    y: number;
  }
): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = URL.createObjectURL(file);
    image.crossOrigin = "anonymous";

    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        reject(new Error("Failed to get 2D context"));
        return;
      }

      // IMPORTANT — keep final output same as crop area
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;

      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height
      );

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }
          resolve(blob);
        },
        "image/jpeg",
        0.9
      );
    };

    image.onerror = (err) => reject(err);
  });
};

export function toSentenceCase(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}


export function formatEnum(value: string): string {
  if (!value) return "";

  return value
    .toLowerCase()
    .replace(/_/g, " ") // replace underscores with spaces
    .split(" ")
    .map(word =>
      word.length > 0
        ? word.charAt(0).toUpperCase() + word.slice(1)
        : ""
    )
    .join(" ");
}

export const setUserData = (data: any) => {
  window.localStorage.removeItem("authorization");
  window.localStorage.setItem("authorization", data.accessToken);
};

export const getToken = () => {
    return window.localStorage["authorization"] || "";
  };

 
  // utils/getSingleImageUrl.ts
export const getSingleImageUrl = (image: string | string[] | undefined | null): string => {
  if (Array.isArray(image)) {
    return image[0] || "";
  }
  return image || "";
};



